export const requiredBillingAddressFormFields = () => {
    const fields = [
        'firstName',
        'lastName',
        'street1',
        'city',
        'state',
        'postalCode'
    ];

    return fields;
};
